import Link from 'next/link';
import React from 'react';
import Loader from '../loader';

const News_item = ({
  data,
  classes = 'grid gap-[1.875rem] grid-cols-1 md:grid-cols-2 xl:grid-cols-3',
  loading,
  drawerItems = false,
}) => {
  const firstItem = data?.[0];

  // ======================= VIEWS
  if (loading) {
    return (
      <div className="w-full flex items-center justify-center pt-[20%]">
        <Loader/>
      </div>
    );
  }
  if (!data || data?.length < 1) {
    return (
      <div className="w-full flex items-center justify-center pt-[20%]">
        No Data
      </div>
    );
  }
  if (drawerItems) {
    return (
      <>
        {data?.map((item) => {
          const { id, image, title, text, slug, date } = item;
          return (
            <article key={id} className={'col-span-1'}>
              <div
                className='border border-jacarta-100 dark:border-jacarta-600 h-full rounded-2xl overflow-hidden transition-shadow hover:shadow-lg'>
                <figure className='group overflow-hidden'>
                  <Link href={`/blog/${slug}`}>
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                      src={image}
                      alt={title}
                      style={{ height: 250 }}
                      className='w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105 '
                    />
                  </Link>
                </figure>

                {/* <!-- Body --> */}
                <div style={{ height: 'calc(100% - 250px)' }}
                     className='dark:bg-[#09092C] rounded-b-[1.25rem] bg-white p-[10%]'>
                  {/* <!-- Meta --> */}
                  <h2
                    className='font-display text-jacarta-700 dark:hover:text-primary hover:text-accent mb-4 text-xl dark:text-white blog-list-text'>
                    <Link href={`/blog/${slug}`}>
                      {title}
                    </Link>
                  </h2>
                  <p className='dark:text-jacarta-200 mb-8 blog-list-text'>{text}</p>

                  {/* <!-- Date / Time --> */}
                  <div className='text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm'>
                    <span>{date}</span>
                  </div>
                </div>
              </div>
            </article>
          );
        })}
      </>
    )
  }
  return (
    <>
      <div className={classes}>
        <article className={'col-span-1 lg:col-span-2 xl:col-span-3'}>
          <div
            className='grid grid-cols-1 lg:grid-cols-2  border border-jacarta-100 dark:border-jacarta-600 h-full w-full rounded-2xl overflow-hidden transition-shadow hover:shadow-lg'>
            <figure className='group overflow-hidden '>
              <Link href={`/blog/${firstItem?.slug}`}>
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={firstItem?.image}
                  alt={firstItem?.title}
                  className='w-full object-cover transition-transform duration-[1600ms] lg:h-[350px] h-auto will-change-transform group-hover:scale-105 '
                />
              </Link>
            </figure>
            {/* <!-- Body --> */}
            <div
              className='dark:bg-[#09092C] rounded-b-[1.25rem] bg-white justify-center h-[calc(100% - 250px)] lg:h-[350px] flex flex-col p-[10%]'>
              {/* <!-- Meta --> */}
              <h2
                className='font-display text-jacarta-700 dark:hover:text-primary hover:text-accent mb-4 text-xl dark:text-white blog-list-text'>
                <Link href={`/blog/${firstItem?.slug}`}>
                  {firstItem?.title}
                </Link>
              </h2>
              <p className='dark:text-jacarta-200 mb-8 blog-list-text'>{firstItem?.text}</p>

              {/* <!-- Date / Time --> */}
              <div className='text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm'>
                <span>{firstItem?.date}</span>
              </div>
            </div>
          </div>
        </article>
        {data?.slice(1)?.map((item) => {
          const { id, image, title, text, slug, date } = item;
          return (
            <article key={id} className={'col-span-1'}>
              <div
                className='border border-jacarta-100 dark:border-jacarta-600 h-full rounded-2xl overflow-hidden transition-shadow hover:shadow-lg'>
                <figure className='group overflow-hidden'>
                  <Link href={`/blog/${slug}`}>
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                      src={image}
                      alt={title}
                      style={{ height: 250 }}
                      className='w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105 '
                    />
                  </Link>
                </figure>

                {/* <!-- Body --> */}
                <div style={{ height: 'calc(100% - 250px)' }}
                     className='dark:bg-[#09092C] rounded-b-[1.25rem] bg-white p-[10%]'>
                  {/* <!-- Meta --> */}
                  <h2
                    className='font-display text-jacarta-700 dark:hover:text-primary hover:text-accent mb-4 text-xl dark:text-white blog-list-text'>
                    <Link href={`/blog/${slug}`}>
                      {title}
                    </Link>
                  </h2>
                  <p className='dark:text-jacarta-200 mb-8 blog-list-text'>{text}</p>

                  {/* <!-- Date / Time --> */}
                  <div className='text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm'>
                    <span>{date}</span>
                  </div>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </>
  );
};

export default News_item;
